import ChatHeader from './chat.header'
import ChatBody from './chat.body'
import ChatForm from './form/chat.form'
import { Stack, Typography } from '@vapor/material'
import { borderColorChat, maxHeightChat } from './common'
import { useTranslation } from 'react-i18next'
import useBreakpoints from 'src/app/hooks/breakpoints/use-breakpoints'
import ChatCRUD from './chat.crud'
import { ThreadFragment } from 'src/api/api.generated'
import { v4 as uuid } from 'uuid'

export default function Chat({
  thread,
  propertyId,
  tenantId,
  backgroundColor,
  insideReservation,
  onBack,
  onArchive,
  onInbox,
  onReservation,
  onToBeRead,
  updateExternalThread,
}: {
  thread: ThreadFragment | null
  propertyId: string
  tenantId: string
  backgroundColor?: string
  insideReservation?: boolean
  onToBeRead?: () => void
  onArchive?: () => void
  onInbox?: () => void
  onReservation?: () => void
  onBack?: () => void
  updateExternalThread?: (props: { lastMessage: string; createdOn: Date }) => void
}) {
  const { t } = useTranslation()
  const { md } = useBreakpoints()
  const { messages, deleteNote, addMessageThread, sendMessageLoading } = ChatCRUD({
    propertyId,
    tenantId,
    threadId: thread?.id ?? null,
  })

  const checkin = thread?.reservation?.reservedResources?.reduce((a, b) => (a.start < b.start ? a : b))?.start ?? undefined
  const checkout = thread?.reservation?.reservedResources?.reduce((a, b) => (a.end > b.end ? a : b))?.end ?? undefined
  const guests = thread?.reservation?.reservedResources?.reduce((previousValue, currentValue) => previousValue + currentValue.adults + currentValue.children, 0) ?? 0
  const resources = thread?.reservation?.reservedResources?.length ?? 0

  return (
    <Stack flexGrow={1} border={1} borderColor={borderColorChat} maxHeight={maxHeightChat({ md, insideReservation })} borderRadius={md ? '8px' : undefined}>
      {thread?.id ? (
        <>
          <ChatHeader
            portalName={thread.origin}
            guestName={thread.reservation.reference.mainGuest.name}
            reservationCode={thread.reservation.reservationCode}
            checkin={checkin}
            checkout={checkout}
            guests={guests}
            resources={resources}
            /* reservationState={thread.reservation.reservationState}
            reservationId={thread.reservationId}
            optionExpiration={thread.reservation.optionExpiration ?? null}
            reservedResources={thread.reservation.reservedResources ?? null} */
            onBack={onBack}
            onArchive={onArchive}
            onInbox={onInbox}
            onReservation={onReservation}
            onToBeRead={onToBeRead}
          />
          <ChatBody messages={messages} backgroundColor={backgroundColor} deleteNote={deleteNote} />
          <ChatForm
            sendMessageLoading={sendMessageLoading}
            onSubmit={async (formValue) => {
              const createdOn = new Date()
              const result = await addMessageThread({
                id: uuid(),
                internalNote: formValue.isNote,
                message: formValue.message,
                auditable: {
                  createdOn,
                },
              })
              if (!result.errors && updateExternalThread) {
                updateExternalThread({ lastMessage: formValue.message, createdOn })
              }

              return result
            }}
          />
        </>
      ) : (
        <>
          <Typography textAlign="center" marginTop={4}>
            {t('pms.messages.select_a_message')}
          </Typography>
        </>
      )}
    </Stack>
  )
}
